import { render, staticRenderFns } from "./subjectType.vue?vue&type=template&id=2137e7ae&scoped=true&"
import script from "./subjectType.vue?vue&type=script&lang=js&"
export * from "./subjectType.vue?vue&type=script&lang=js&"
import style0 from "./subjectType.vue?vue&type=style&index=0&id=2137e7ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2137e7ae",
  null
  
)

export default component.exports